var components
try {
  components = {
    uPopup: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-popup/u-popup" */ "uview-ui/components/u-popup/u-popup.vue"
      )
    },
    uModal: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-modal/u-modal" */ "uview-ui/components/u-modal/u-modal.vue"
      )
    },
    tram: function () {
      return import(
        /* webpackChunkName: "components/tram/tram" */ "@/components/tram/tram.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = (_vm.info.deposit / 100).toFixed(2)
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.show1 = false
    }
    _vm.e1 = function ($event) {
      _vm.active = !_vm.active
    }
    _vm.e2 = function ($event) {
      _vm.show1 = false
    }
    _vm.e3 = function ($event) {
      _vm.show5 = false
    }
    _vm.e4 = function ($event) {
      _vm.show2 = false
    }
    _vm.e5 = function ($event) {
      _vm.show6 = false
    }
    _vm.e6 = function ($event) {
      _vm.show3 = false
    }
    _vm.e7 = function ($event) {
      _vm.show4 = false
    }
    _vm.e8 = function ($event) {
      _vm.show7 = false
    }
    _vm.e9 = function ($event) {
      _vm.show = false
    }
    _vm.e10 = function ($event) {
      _vm.show = false
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }